import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from '@aviv-unified-frontend/runtime/router';
import { Box } from '@gemini/core';
import { InfoState } from '@gemini/ui';
import { useBrandConfiguration } from '../../brands/context';
import { serpStaticAssetsPath, projectSerpStaticAssetsPath } from '../../helpers/constants';
import { useSerpTranslation } from '../../hooks/useI18n';
export const errorTestId = 'search-not-available-error';
export const ErrorContainer = () => {
    const navigate = useNavigate();
    const { t } = useSerpTranslation();
    const { errorBackLink, searchType } = useBrandConfiguration() || {};
    const description = t('error_page.description');
    const title = t('error_page.title');
    const relaunchButton = t('error_page.cta_relaunch');
    const homePageButton = t('error_page.cta_go_to_hp');
    const link = errorBackLink ?? '/';
    return (_jsx(Box, { justifyContent: "center", display: "flex", children: _jsx(InfoState, { testId: errorTestId, description: description, title: title, image: `${searchType === 'project' ? projectSerpStaticAssetsPath : serpStaticAssetsPath}/images/error-info.webp`, startButtonProps: { children: relaunchButton, onPress: () => window.location.reload() }, endButtonProps: {
                children: homePageButton,
                onPress: () => {
                    navigate(link);
                },
            } }) }));
};
